exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overlayContainer{-ms-grid-row:2;grid-row:2;-ms-grid-column:1;grid-column:1;overflow:hidden;position:relative}@media (max-width:450px){.overlayContainer{display:none}}.videoPlayer.barker:not(.float) .overlayContainer,.videoPlayer.float .overlayContainer{display:none}", ""]);

